import React from 'react'
import classes from './Footer.module.css'

const Footer = () => {
  return (
    <div className={classes.container}>
          © VideoCentral-2025. All rights reserved.
    </div>
  )
}

export default Footer
